import { SignaturePad } from "@/components/oprema/PrimopredajaStep";
import { Field } from "./shared";
import type { EquipmentEvidenceInput } from "@/lib/api/oprema";
import { useId, useState } from "react";
import { Button } from "@/components/ui/button";

export interface HandoverProof extends EquipmentEvidenceInput {
  potpis: File | null;
}
export const emptyProof = (): HandoverProof => ({
  potpis: null,
  bez_fotke_razlog: "",
  bez_potpisa_razlog: "",
});
export function proofReady(
  photos: File[],
  proof: HandoverProof,
  allowException: boolean,
) {
  return !proofMissing(photos, proof, allowException);
}
export function proofMissing(
  photos: File[],
  proof: HandoverProof,
  allowException: boolean,
) {
  if (!photos.length && !(allowException && proof.bez_fotke_razlog?.trim()))
    return "Dodaj fotku";
  if (!proof.potpis && !(allowException && proof.bez_potpisa_razlog?.trim()))
    return "Dodaj potpis";
  return "";
}
export function proofInput(
  photos: File[],
  proof: HandoverProof,
  allowException: boolean,
): EquipmentEvidenceInput {
  return {
    ...(allowException && !photos.length
      ? { bez_fotke_razlog: proof.bez_fotke_razlog?.trim() }
      : {}),
    ...(allowException && !proof.potpis
      ? { bez_potpisa_razlog: proof.bez_potpisa_razlog?.trim() }
      : {}),
  };
}
export function HandoverProofFields({
  value,
  onChange,
  label,
  photos,
  allowException,
  error,
}: {
  value: HandoverProof;
  onChange: (value: HandoverProof) => void;
  label: "Predao" | "Primio";
  photos: File[];
  allowException: boolean;
  error?: string;
}) {
  const [exceptionOpen, setExceptionOpen] = useState(false);
  const [signatureOpen, setSignatureOpen] = useState(false);
  const exceptionId = useId();
  return (
    <section className="equipment-card" aria-label={`Potpis ${label}`}>
      <Button
        type="button"
        variant="outline"
        className={value.potpis ? "equipment-proof-ready" : ""}
        onClick={() => setSignatureOpen((old) => !old)}
        aria-expanded={signatureOpen}
      >
        {value.potpis ? "✓ Potpisano · Promijeni" : `Potpiši (${label})`}
      </Button>
      <div hidden={!signatureOpen}>
        <SignaturePad
          label={`Potpis ${label}`}
          onChange={(potpis) => onChange({ ...value, potpis })}
        />
      </div>
      {error && (
        <p className="equipment-error" role="alert">
          {error}
        </p>
      )}
      {allowException && (!photos.length || !value.potpis) && (
        <div>
          <Button
            type="button"
            variant="outline"
            aria-expanded={exceptionOpen}
            aria-controls={exceptionId}
            onClick={() => setExceptionOpen((open) => !open)}
          >
            Pošalji bez fotke ili potpisa (uz razlog)
          </Button>
          <div
            id={exceptionId}
            hidden={!exceptionOpen}
            className="equipment-field"
          >
            <p>
              Iznimka se bilježi uz dokument. Svaki nedostatak traži svoj
              razlog.
            </p>
            {!photos.length && (
              <Field label="Razlog bez fotke">
                <textarea
                  aria-label="Razlog bez fotke"
                  value={value.bez_fotke_razlog ?? ""}
                  onChange={(e) =>
                    onChange({ ...value, bez_fotke_razlog: e.target.value })
                  }
                />
              </Field>
            )}
            {!value.potpis && (
              <Field label="Razlog bez potpisa">
                <textarea
                  aria-label="Razlog bez potpisa"
                  value={value.bez_potpisa_razlog ?? ""}
                  onChange={(e) =>
                    onChange({ ...value, bez_potpisa_razlog: e.target.value })
                  }
                />
              </Field>
            )}
          </div>
        </div>
      )}
    </section>
  );
}
